export const config = {

  //apiUrl: 'http://localhost:6070/api/'
  apiUrl: 'https://admin.ng-cloud.cl:6070/api/'
}